import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Leaf, XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background nutri-grain px-4">
      <div className="bg-card border rounded-2xl p-10 max-w-md w-full text-center space-y-5 shadow-sm" data-testid="payment-cancel">
        <div className="flex items-center justify-center gap-2 text-primary">
          <Leaf className="h-6 w-6" /> <span className="font-heading text-xl font-semibold">DietFlix</span>
        </div>
        <XCircle className="h-14 w-14 text-muted-foreground mx-auto" />
        <h1 className="font-heading text-2xl font-semibold">Pagamento annullato</h1>
        <p className="text-muted-foreground">Nessun addebito effettuato. Puoi riprovare quando vuoi.</p>
        <Button className="w-full" onClick={() => navigate("/dashboard")} data-testid="cancel-back-button">Torna alla dashboard</Button>
      </div>
    </div>
  );
}
